import { gql } from "@apollo/client";

export const CREATE_REMEDIATION_QUEUE = gql`
  mutation CreateRemediationQueue(
    $cron: String
    $report_fields: [String]
    $filters_config: FiltersConfigInput!
    $max_concurrent_opened_tickets: Int
    $state: RemediationQueueState
    $ticket_provider_id: String!
    $finding_filter: FindingFilterInput
    $title: String!
    $value_mapping: JSONString!
    $days_to_reopen_tickets: Int
    $report_dashboard_id: Int
    $should_add_dashboard_link: Boolean
    $template_id: Int
  ) {
    create_remediation_queue(
      cron: $cron
      report_fields: $report_fields
      finding_filter: $finding_filter
      report_dashboard_id: $report_dashboard_id
      should_add_dashboard_link: $should_add_dashboard_link
      filters_config: $filters_config
      max_concurrent_opened_tickets: $max_concurrent_opened_tickets
      state: $state
      ticket_provider_id: $ticket_provider_id
      title: $title
      value_mapping: $value_mapping
      days_to_reopen_tickets: $days_to_reopen_tickets
      template_id: $template_id
    ) {
      remediation_queue {
        id
      }
    }
  }
`;

export const UPDATE_REMEDIATION_QUEUE = gql`
  mutation UpdateRemediationQueue(
    $cron: String
    $report_fields: [String]
    $id: String!
    $max_concurrent_opened_tickets: Int
    $state: RemediationQueueState
    $title: String
    $report_dashboard_id: Int
    $should_add_dashboard_link: Boolean
    $value_mapping: JSONString
    $filters_config: FiltersConfigInput
    $days_to_reopen_tickets: Int
    $ticket_provider_id: String!
    $template_id: Int
  ) {
    update_remediation_queue(
      cron: $cron
      report_fields: $report_fields
      id: $id
      report_dashboard_id: $report_dashboard_id
      should_add_dashboard_link: $should_add_dashboard_link
      max_concurrent_opened_tickets: $max_concurrent_opened_tickets
      state: $state
      title: $title
      value_mapping: $value_mapping
      ticket_provider_id: $ticket_provider_id
      filters_config: $filters_config
      days_to_reopen_tickets: $days_to_reopen_tickets
      template_id: $template_id
    ) {
      ok
    }
  }
`;

export const SYNC_QUEUE = gql`
  mutation SyncQueue($remediation_queue_id: String!) {
    remediation_queue_sync_now(remediation_queue_id: $remediation_queue_id) {
      tickets_opened
      tickets_failed_to_open
    }
  }
`;
